import { GenIcon } from '../helpers/IconBase.es.js';

const TelephoneOutlined = (props) => {
  return GenIcon({
    tag: "svg",
    attr: { viewBox: "0 0 24 25", fill: "none" },
    child: [
      {
        tag: "path",
        attr: {
          d: "M18.965 17.2101L17.792 16.0371C17.5107 15.7559 17.1292 15.598 16.7315 15.598C16.3337 15.598 15.9523 15.7559 15.671 16.0371L14.749 16.9591C14.6493 17.0612 14.5212 17.1308 14.3814 17.159C14.2415 17.1872 14.0964 17.1726 13.965 17.1171C12.629 16.5321 11.309 15.6451 10.132 14.4681C9.02333 13.3697 8.12757 12.0756 7.48999 10.6511C7.43223 10.5154 7.41679 10.3653 7.44569 10.2206C7.4746 10.0759 7.5465 9.9433 7.65199 9.84013L8.47799 9.01413C9.14899 8.34313 9.14899 7.39413 8.56299 6.80813L7.38999 5.63513C7.01494 5.26019 6.50632 5.04956 5.97599 5.04956C5.44567 5.04956 4.93705 5.26019 4.56199 5.63513L3.90999 6.28613C3.16899 7.02713 2.85999 8.09613 3.05999 9.15613C3.55399 11.7691 5.07199 14.6301 7.52099 17.0791C9.96999 19.5281 12.831 21.0461 15.444 21.5401C16.504 21.7401 17.573 21.4311 18.314 20.6901L18.965 20.0391C19.1508 19.8534 19.2982 19.6329 19.3987 19.3902C19.4993 19.1475 19.5511 18.8873 19.5511 18.6246C19.5511 18.3619 19.4993 18.1018 19.3987 17.8591C19.2982 17.6164 19.1508 17.3959 18.965 17.2101V17.2101Z",
          stroke: "#434657",
          strokeWidth: "1.5",
          strokeMiterlimit: "10",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      },
      {
        tag: "path",
        attr: {
          d: "M13 7.59111C13.5289 7.58242 14.0541 7.68019 14.5444 7.87861C15.0347 8.07703 15.48 8.37205 15.854 8.74611",
          stroke: "#82869E",
          strokeWidth: "1.5",
          strokeMiterlimit: "10",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      },
      {
        tag: "path",
        attr: {
          d: "M18.682 5.91821C17.9366 5.17092 17.051 4.57826 16.0759 4.17429C15.1008 3.77031 14.0555 3.56299 13 3.56421",
          stroke: "#82869E",
          strokeWidth: "1.5",
          strokeMiterlimit: "10",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      },
      {
        tag: "path",
        attr: {
          d: "M17.009 11.6001C17.0177 11.0712 16.9199 10.546 16.7215 10.0557C16.5231 9.56543 16.2281 9.12005 15.854 8.74609",
          stroke: "#82869E",
          strokeWidth: "1.5",
          strokeMiterlimit: "10",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      },
      {
        tag: "path",
        attr: {
          d: "M18.682 5.91821C19.4293 6.66357 20.022 7.54924 20.4259 8.52434C20.8299 9.49944 21.0372 10.5447 21.036 11.6002",
          stroke: "#82869E",
          strokeWidth: "1.5",
          strokeMiterlimit: "10",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      }
    ]
  })(props);
};

export { TelephoneOutlined };
